exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".legal[data-v-09976a33]{margin-bottom:128px}.legal__headline h5[data-v-09976a33]{margin-bottom:16px;font-weight:700;font-size:36px;line-height:37px}.legal__sub-line[data-v-09976a33]{font-weight:400;font-size:14px;line-height:22px;color:#a3a3a3;margin-bottom:65px}.legal__content[data-v-09976a33]{font-weight:400;font-size:17px;line-height:28px;color:#1c1c1c}.legal__content[data-v-09976a33],.social-wrap[data-v-09976a33]{margin-bottom:64px}.legal__content p[data-v-09976a33]{margin-bottom:25px}.legal__content p[data-v-09976a33]:last-of-type{margin-bottom:0}", ""]);

// exports
